import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '../ui/alert-dialog';
import { Button } from '../ui/button';

// onConfirm returns false to keep the dialog open (e.g. on error).
export const ConfirmAction = ({ testId, label, icon: Icon, title, description, confirmLabel, onConfirm, destructive = false, variant = 'outline', className = '' }) => {
  const [open, setOpen] = useState(false), [busy, setBusy] = useState(false);
  const run = async (event) => {
    event.preventDefault();
    setBusy(true);
    try { if ((await onConfirm()) !== false) setOpen(false); } finally { setBusy(false); }
  };
  return (
    <span onClick={(event) => event.stopPropagation()} className="inline-flex">
      <Button type="button" size="sm" variant={variant} className={className} data-testid={testId} disabled={busy} onClick={() => setOpen(true)}>
        {Icon && <Icon className="mr-1.5 h-4 w-4" />}{label}
      </Button>
      <AlertDialog open={open} onOpenChange={(next) => !busy && setOpen(next)}>
        <AlertDialogContent data-testid={`${testId}-dialog`}>
          <AlertDialogHeader>
            <AlertDialogTitle>{title}</AlertDialogTitle>
            <AlertDialogDescription>{description}</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid={`${testId}-dismiss`} disabled={busy}>Indietro</AlertDialogCancel>
            <AlertDialogAction data-testid={`${testId}-confirm`} disabled={busy} onClick={run} className={destructive ? 'bg-red-600 text-white hover:bg-red-700' : 'bg-blue-700 text-white hover:bg-blue-800'}>
              {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}{confirmLabel}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </span>
  );
};
